export default __webpack_public_path__ + "static/media/medicaltest_time_icon.db120b98.svg";